import { render, staticRenderFns } from "./help.vue?vue&type=template&id=d890600a&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d890600a')) {
      api.createRecord('d890600a', component.options)
    } else {
      api.reload('d890600a', component.options)
    }
    module.hot.accept("./help.vue?vue&type=template&id=d890600a&", function () {
      api.rerender('d890600a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/help/help.vue"
export default component.exports